import { CircleAlert } from "lucide-react";
import type { ReactNode } from "react";

import { focusFirstField } from "@/lib/forms";

export type FormErrorField = {
  id: string;
  label: string;
  message?: string;
};

/** One persistent correction panel keeps individual field heights stable. */
export function FormErrorSummary({ children, fields = [] }: { children?: ReactNode; fields?: FormErrorField[] }) {
  const errors = fields.filter((field) => field.message);
  if (!children && errors.length === 0) return null;

  return (
    <div role="alert" className="flex min-w-0 gap-3 rounded-xl border border-destructive/30 bg-card px-4 py-3 text-sm">
      <CircleAlert aria-hidden="true" size={20} className="mt-0.5 shrink-0 text-destructive" />
      <div className="min-w-0 flex-1">
        {errors.length > 0 ? (
          <>
            <p className="font-semibold">
              {errors.length} {errors.length > 1 ? "champs à vérifier" : "champ à vérifier"}
            </p>
            <ul className="mt-1">
              {errors.map((field) => (
                <li key={field.id}>
                  <a
                    href={`#${field.id}`}
                    onClick={(event) => {
                      event.preventDefault();
                      focusFirstField([field.id]);
                    }}
                    className="block min-h-11 content-center rounded-md py-2 leading-relaxed [overflow-wrap:anywhere] hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
                  >
                    <span className="font-medium underline decoration-destructive/40 underline-offset-4">
                      {field.label}
                    </span>
                    <span className="text-foreground/80"> : {field.message}</span>
                  </a>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p className="leading-relaxed [overflow-wrap:anywhere]">{children}</p>
        )}
      </div>
    </div>
  );
}
